import { ApiInvoice } from 'src/interfaces/interfaces.generated';

export const findInvoiceShopId = (
  array: ApiInvoice[] | undefined,
  accessor: string
): number | undefined => (array && array.length > 0 ? array[0][accessor] : undefined);
